<template>
    <ActionDropdown cssClass="ms-1" ref="actions" :actions="actions" />
    <UserProfileActionModal :user="user" :application="application" ref="UserProfileActionModal"
        @setUserProfiles="$refs['UserProfileGroupedModal'].show($event.user, $event.application.id)" @updated="$emit('created')" />
    <UserProfileGroupedModal ref="UserProfileGroupedModal"
        @setExpirations="$refs['UserProfileGroupedExpirationsModal'].show($event)" />
    <UserProfileGroupedExpirationsModal ref="UserProfileGroupedExpirationsModal" @updated="$emit('created')" />
    <UserProfileCloneModal :user="user" :application="application" ref="UserProfileCloneModal"
        @submit="$emit('submit', $event)" />
</template>
<script>
import UserProfileActionModal from "@/components/userProfile/UserProfileActionModal.vue";
import UserProfileCloneModal from "@/components/userProfile/UserProfileCloneModal.vue";
import ActionDropdown from "@/components/common/list/ActionDropdown.vue";
import UserProfileGroupedModal from "@/components/userProfile/UserProfileGroupedModal.vue";
import UserProfileGroupedExpirationsModal from "@/components/userProfile/UserProfileGroupedExpirationsModal.vue";

export default {
    components: {
        UserProfileActionModal,
        UserProfileCloneModal,
        ActionDropdown,
        UserProfileGroupedModal,
        UserProfileGroupedExpirationsModal,
    },
    data() {
        return {
            formData: {},
        };
    },
    props: {
        btnClass: {
            type: String,
            default: 'btn btn-sm btn-outline-dark ms-2',
        },
        user: {
            type: Object,
        },
        application: {
            type: Object,
        },
    },
    emits: [
        'added',
        'created',
        'submit',
    ],
    methods: {
        showUserProfileActionModal() {
            this.$refs['UserProfileActionModal'].show();
        },
        showUserProfileCloneModal() {
            this.$refs['UserProfileCloneModal'].show();
        },
    },
    computed: {
        actions() {
            return [
                {
                    label: this.i18n('Add New'),
                    fn: () => {
                        this.showUserProfileActionModal();
                    },
                    starred: true,
                    if: this.user ? (this.user?.acl?.attachUserProfile || this.user.acl.update) : true,
                },
                {
                    label: this.i18n('Clone profiles'),
                    fn: () => {
                        this.showUserProfileCloneModal();
                    },
                    if: this.user ? this.user?.acl?.showCloneUserProfileButton : this.can('CLONE_USER_PROFILE_BUTTON_SHOW'),
                },
            ];
        },
    },
};
</script>
